import { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { MultiCategorySelect } from "@/components/MultiCategorySelect";
import { toast } from "sonner";
import { Lightbulb, Loader2, Clock } from "lucide-react";

export function TallerTypesSection({ selected, onChange }) {
  const [cats, setCats] = useState([]);
  const [mine, setMine] = useState([]);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const loadMine = () => api.get("/business/category-suggestions").then((r) => setMine(r.data)).catch(() => {});
  useEffect(() => { api.get("/categories").then((r) => setCats(r.data || [])).catch(() => {}); loadMine(); }, []);
  const suggest = async () => {
    if (name.trim().length < 2) return;
    setBusy(true);
    try {
      await api.post("/business/category-suggestions", { name: name.trim() });
      toast.success("Sugerencia enviada. Te avisaremos cuando el Administrador la apruebe.");
      setName(""); loadMine();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const pending = mine.filter((s) => s.status === "pending");
  return (
    <div className="space-y-3" data-testid="taller-types-section">
      <div>
        <Label>Tipos de talleres que realizo <span className="text-destructive">*</span></Label>
        <p className="text-xs text-muted-foreground mt-0.5">Marca todos los que haces (mínimo 1). Aparecen en tu perfil público.</p>
      </div>
      <MultiCategorySelect options={cats} selected={selected} onChange={onChange} />
      <div className="rounded-xl border border-dashed p-3 space-y-2" data-testid="category-suggest-box">
        <p className="text-xs font-medium flex items-center gap-1.5"><Lightbulb className="w-4 h-4 text-primary" />¿No está tu tipo de taller? Sugiérelo</p>
        <div className="flex gap-2">
          <Input value={name} maxLength={40} onChange={(e) => setName(e.target.value)} placeholder="Ej. Encuadernación"
            onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); suggest(); } }} data-testid="category-suggest-input" />
          <Button type="button" variant="outline" onClick={suggest} disabled={busy || name.trim().length < 2} data-testid="category-suggest-btn">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Enviar sugerencia"}
          </Button>
        </div>
        <p className="text-[11px] text-muted-foreground">El Administrador la revisa; si la aprueba, se agrega al listado y a tu perfil.</p>
        {pending.length > 0 && (
          <div className="flex flex-wrap gap-1.5" data-testid="my-pending-suggestions">
            {pending.map((s) => <Badge key={s.id} variant="outline" className="gap-1"><Clock className="w-3 h-3" />{s.name} · en revisión</Badge>)}
          </div>
        )}
      </div>
    </div>
  );
}
